/**
 * @generated SignedSource<<2381eb29b26006c4348f6bd01aaf47b4>>
 * @relayHash c7cac68ba4471f191152224845385747
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f93d76c6ef6566bb8fcd64936b6b1bff727e8f9d0d3cc511066903d28697d6e0

import type { ConcreteRequest, Query } from 'relay-runtime';
export type actions_versionHasReleaseNoteQuery$variables = {
  versionId: string;
};
export type actions_versionHasReleaseNoteQuery$data = {
  readonly jira: {
    readonly version: {
      readonly hasReleaseNote?: boolean | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type actions_versionHasReleaseNoteQuery = {
  response: actions_versionHasReleaseNoteQuery$data;
  variables: actions_versionHasReleaseNoteQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "versionId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "versionId"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasReleaseNote"
    }
  ],
  "type": "JiraVersion"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "actions_versionHasReleaseNoteQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "actions_versionHasReleaseNoteQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              (v2/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "f93d76c6ef6566bb8fcd64936b6b1bff727e8f9d0d3cc511066903d28697d6e0",
    "metadata": {},
    "name": "actions_versionHasReleaseNoteQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ef82cca181efdaab2168c14aa947a137";

export default node;
